import { parseAsJson, useQueryState } from 'nuqs';

import { modalDataSchema } from './PatientContext.jsx';

export const usePatientModalData = () => {
  const [modalData, setModalData] = useQueryState('pmd', parseAsJson(modalDataSchema.parse));

  return { modalData, setModalData };
};
